var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-settings",
    "data-name": "Icon feather-settings",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1918",
    "data-name": "Path 1918",
    d: "M19.54,16.52a3.02,3.02,0,1,1-3.02-3.02A3.02,3.02,0,0,1,19.54,16.52Z",
    transform: "translate(-5.02 -5.02)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1919",
    "data-name": "Path 1919",
    d: "M18.227,14.227a1.5,1.5,0,0,0,.3,1.655l.055.055a1.819,1.819,0,1,1-2.573,2.573l-.055-.055a1.512,1.512,0,0,0-2.564,1.073v.155a1.818,1.818,0,1,1-3.636,0V19.6a1.5,1.5,0,0,0-.982-1.373,1.5,1.5,0,0,0-1.655.3l-.055.055a1.819,1.819,0,1,1-2.573-2.573l.055-.055a1.512,1.512,0,0,0-1.073-2.564H3.318a1.818,1.818,0,0,1,0-3.636H3.4a1.5,1.5,0,0,0,1.373-.982,1.5,1.5,0,0,0-.3-1.655l-.055-.055A1.819,1.819,0,1,1,6.991,4.491l.055.055a1.5,1.5,0,0,0,1.655.3h.073a1.5,1.5,0,0,0,.909-1.373V3.318a1.818,1.818,0,1,1,3.636,0V3.4a1.512,1.512,0,0,0,2.564,1.073l.055-.055a1.819,1.819,0,1,1,2.573,2.573l-.055.055a1.5,1.5,0,0,0-.3,1.655v.073a1.5,1.5,0,0,0,1.373.909h.155a1.818,1.818,0,1,1,0,3.636H19.6a1.5,1.5,0,0,0-1.373.909Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon8);
export default __webpack_public_path__ + "static/media/icon8.c9ca5f2d753ab23f9b4a6e886a654ac4.svg";
export { ForwardRef as ReactComponent };